import React from 'react';
import styled from 'styled-components';
import { AI_TOOLS } from '@constants';
import { GRID_MODES } from '@containers/gridMode';
import { Header } from '@app/navigation/header';
import { ExtraWideBody } from '@ui';
import TableAnalysisTool from '@containers/TableAnalysis/TableAnalysisTool';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const tool = AI_TOOLS.CLIENT_PEER_ANALYSIS_MATRIX_MODE;

function ClientPeerTableAnalysis() {
  const [docMode] = React.useState(GRID_MODES.clientPeerAnalysis);

  return (
    <PageWrapper>
      <Header />
      <ExtraWideBody withFooter>
        <TableAnalysisTool docMode={docMode} tool={tool} />
      </ExtraWideBody>
    </PageWrapper>
  );
}

export default ClientPeerTableAnalysis;
